import { render } from "./ContactDetailsTab.vue?vue&type=template&id=39d3eaa6&ts=true"
import script from "./ContactDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__